<template>
  <header>
    <IconBackward 
      stroke="2.5"
      @click="$emit('prev')"
    />

    <AppSubTitle v-text="title"/>

    <IconBackward 
      stroke="2.5"
      @click="$emit('next')"
    />
  </header>
</template>


<script>
import IconBackward from '@icons/IconBackward';
import AppSubTitle from '../ui/AppSubTitle';

export default {
  name: 'AppRating_Title',

  emits: ['prev', 'next'],

  components: {
    IconBackward,
    AppSubTitle,
  },

  props: {
    title: String,
  },
};
</script>


<style lang="scss" scoped>
header {
  background-color: var(--color-primary);
  border-radius: 10px 10px 2px 2px;
  color: var(--color-light);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;

  h2 {
    text-transform: none;
    font-weight: bold;
    font-family: Arial, Helvetica, sans-serif;
    text-align: center;
    line-height: 1;
    padding: 6px 0;
    font-size: 24px;
  }

  svg {
    font-size: 20px;

    @media (hover: hover) {
      cursor: pointer;
      transition: scale .1s, opacity .1s;
      &:hover {
        opacity: .9;
        scale: .95;
      }
    }

    &:nth-of-type(1) {
      transform: rotate(180deg);
    }
  }

  @media screen and (min-width: 800px) and (orientation: landscape) {
    h2 {
      font-size: 36px;
    }

    svg {
      font-size: 32px;
    }
  }
}
</style>